module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('strong', [_vm._v("IT AIN’T MY BIRTHDAY BUT I GOT MY NAME ON THE CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("LYRIC FROM SONG: "), _c('strong', [_vm._v("“STUNTIN’ LIKE MY DADDY”")]), _vm._v(" ON ALBUM: "), _c('strong', [_vm._v("LIKE FATHER, LIKE SON")]), _vm._v(" BY ARTIST")]), _vm._v(": "), _c('strong', [_vm._v("BIRDMAN AND LIL WAYNE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("One of the names for money is the same as the dessert that is eaten in celebration of another year a human has lived. While no one would observe an annually occurring day 365 times a year, each day is equally joyous to me because of the income that is constantly flowing in, and is therefore worthy of celebration.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('strong', [_vm._v("AFTER BIG BUCKS, NO WHAMMY")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("LYRIC FROM SONG: "), _c('strong', [_vm._v("“WEED & MONEY”")]), _vm._v(" ON ALBUM: "), _c('strong', [_vm._v("GHETTO D")]), _vm._v(" BY ARTIST")]), _vm._v(": "), _c('strong', [_vm._v("MASTER P")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There are some risks when it comes to the pursuit of financial success in the rap industry, just as contestants on 1980s television game show "), _c('em', [_vm._v("Press Your Luck")]), _vm._v(" risked losing all their money at the hands of a creepy red cartoon character.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("SWIMMING IN THE MONEY, COME AND FIND ME, NEMO")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("LYRIC FROM SONG")]), _vm._v(": "), _c('strong', [_vm._v("“FOREVER”")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BY ARTIST")]), _vm._v(": DRAKE "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ON ALBUM")]), _vm._v(": "), _c('strong', [_vm._v("MORE THAN A GAME (SOUNDTRACK)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It is possible that you could have so much money that there would be nowhere practical to store it all and eventually every room of your house would be filled with paper currency. Anyone who stopped by to visit you in this virtual ocean of money would have as much trouble finding you as an animated talking cartoon fish father had finding his animated talking cartoon fish son.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e7764ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part01ch03.vue
// module id = 87
// module chunks = 0